import React, { useEffect, useState } from "react";
import songStyle from "./styles";
import { Avatar, Box, Typography, Button, Link } from "@mui/material";
import { NftFaq } from "../../src/constant/faq";
import Faq from "../../src//components/common/Faq";
import { useQuery } from "react-query";
import fetcher from "../../src/dataProvider";
import { STRAPI_API_URL } from "../../src/constant/appConstants";

const FAQs = (props) => {
  const [homeFaq, setHomeFaq] = useState("");
  const { data: homeFaqData } = useQuery(
    `${STRAPI_API_URL}/faq-questions`,
    () =>
      fetcher.get(`${STRAPI_API_URL}/faq-questions`, {
        params: {
          [`filters[faq_category][category_title][$eq]`]: props.slug
            ? `faq-song-${props.slug}`
            : "Home FAQ",
          populate: "*",
          sort: ["sequence"],
        },
      })
  );

  useEffect(() => {
    if (homeFaqData) {
      setHomeFaq(homeFaqData);
    }
  }, [homeFaqData]);
  return (
    <Box id="Faqs" sx={songStyle.FAQSection}>
      <Box sx={songStyle.FAQRow}>
        {homeFaq?.data?.length > 0 && <Faq faqs={homeFaq} />}
      </Box>
    </Box>
  );
};

export default FAQs;
